import React from 'react'

const AddressPin = () => {
  return (
    <svg width="12" height="16" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.6875 0.444336C1.7525 0.444336 0.1875 2.00934 0.1875 3.94434C0.1875 6.56934 3.6875 10.4443 3.6875 10.4443C3.6875 10.4443 7.1875 6.56934 7.1875 3.94434C7.1875 2.00934 5.6225 0.444336 3.6875 0.444336ZM1.1875 3.94434C1.1875 2.56434 2.3075 1.44434 3.6875 1.44434C5.0675 1.44434 6.1875 2.56434 6.1875 3.94434C6.1875 5.38434 4.7475 7.53934 3.6875 8.88434C2.6475 7.54934 1.1875 5.36934 1.1875 3.94434Z" fill="#202020"/>
<path d="M3.6875 5.19434C4.37786 5.19434 4.9375 4.63469 4.9375 3.94434C4.9375 3.25398 4.37786 2.69434 3.6875 2.69434C2.99714 2.69434 2.4375 3.25398 2.4375 3.94434C2.4375 4.63469 2.99714 5.19434 3.6875 5.19434Z" fill="#202020"/>
</svg>

  )
}

export default AddressPin